import { AppSettings } from "booking_app/values/app-settings";
import { HotelAmenitiesService } from "booking_app/services/hotels/hotel-amenities.service";

export class HotelDescriptionController {
  static $inject = ["$rootScope", "$timeout", "AppSettings", "HotelAmenitiesService"];

  hotelDetail: any;

  constructor(
    private $rootScope: any,
    private $timeout: any,
    private appSettings: AppSettings,
    private hotelAmenitiesService: HotelAmenitiesService,
  ) {
    this.$rootScope.globalState.showFullDescription = false;
  }

  toggleDescription(): void {
    this.$rootScope.globalState.showFullDescription = !this.showFullDescription() ? true : false;
    // This scroll event is for the sticky headers computation
    // computation finish first before the hide/show therfore causing some issues on the display
    this.$timeout(() => this.triggerScrollEvent(), 100);
  }

  showFullDescription(): boolean {
    return this.$rootScope.globalState.showFullDescription;
  }

  isDescriptionLoading(): boolean {
    return !this.hotelDetail.description;
  }

  shouldShowAmenities(): boolean {
    return this.hotelDetail && (this.hasGuestLove() || this.hasAmenities());
  }

  hasGuestLove(): boolean {
    return this.hotelAmenitiesService.hasGuestLove(this.hotelDetail);
  }

  guestLoveList(): string[] {
    return this.hotelAmenitiesService.guestLoveList(this.hotelDetail);
  }

  hasAmenities(): boolean {
    return this.hotelAmenitiesService.hasAmenities(this.hotelDetail);
  }

  private triggerScrollEvent(): void {
    const scrollEvent = window.document.createEvent("UIEvents");
    scrollEvent.initEvent("scroll", true, true);
    window.dispatchEvent(scrollEvent);
  }
}
